import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DigitalOrder as SchemaDigitalOrder } from '../schemas/DigitalOrder';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetDigitalOrderContentType = '' as const;
export type GetDigitalOrderRequest = undefined;
export type GetDigitalOrderResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaDigitalOrder;
    };
};
export type GetDigitalOrderResponseSuccess = GetDigitalOrderResponses['200']['application/json'];
export type GetDigitalOrderSearchParams = {
    signature: string;
};
export type GetDigitalOrderPathParameters = {
    store_slug: string;
    order_id: string;
};
export const GetDigitalOrderUrl = '/{store_slug}/digital_orders/{order_id}' as const;
export const GetDigitalOrderMethod = 'GET' as const;
export const getGetDigitalOrderUrl = (params: GetDigitalOrderPathParameters) =>
    GetDigitalOrderUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetDigitalOrderPathParameters) =>
        String(params[param])
    );
